import React from "react";
import { StyleSheet, View } from "react-native";

import colors from "@constants/color";
import Tick from "@assets/svg/MyDeliveries/Tick";
import Text from "@components/CustomText";

const PaymentMode = ({ payment_mode, payment_tag }) => {
  return (
    <View style={styles.paymentTag}>
      <Tick visible={payment_mode === "PREPAID"} />
      <Text
        variant="caption_3"
        style={[
          styles.paymentTagText,
          {
            color:
              payment_mode === "PREPAID"
                ? colors.lightBlack
                : colors.plain_green,
            marginLeft: payment_mode === "PREPAID" ? 4 : 0,
          },
        ]}
      >
        {payment_tag}
      </Text>
    </View>
  );
};

export default PaymentMode;

const styles = StyleSheet.create({
  paymentTag: {
    borderRadius: 20,
    borderWidth: 1,
    paddingHorizontal: 8,
    paddingVertical: 2,
    alignItems: "center",
    marginHorizontal: 8,
    justifyContent: "center",
    borderColor: colors.lighterBlack,
    flexDirection: "row",
    backgroundColor: colors.white,
  },
  paymentTagText: {
    color: colors.plain_green,
    fontWeight: "bold",
  },
});
